import { render, staticRenderFns } from "./PromocodeTabLinks.vue?vue&type=template&id=7a729da5"
import script from "./PromocodeTabLinks.vue?vue&type=script&lang=js"
export * from "./PromocodeTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports